import React from 'react'
import { connect } from 'react-redux'
import { AbstractShelfManagementEditComponent, mapStateToProps } from './abstract'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import * as route from '~/helper/constant/route'
import { withTranslation } from 'react-i18next'
import { Button, Input, TextArea, Checkbox } from '~/components/form'
import { Loading } from '~/components/loader'

class ShelfManagementEditComponent extends AbstractShelfManagementEditComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }


    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Loading status={this.state.loading} text={this.state.loading_text} />
                <Sidebar id="library" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.library.menu}>{t('library:library')} > </a>
                            </li>
                            <li>
                                <a href={route.admin.library.shelfmanagement.view}>{t('library:shelfmanagement')} > </a>
                            </li>
                            <li>{t('common:EditBtn')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('library:shelfmanagement')} :</h5>
                            </div>
                        </div>
                    </div>
                    <div className="main-form">
                    <form>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('library:books')} *</label>
                                    <Input name="name" onChange={this._handleChange} placeholder={t('library:books')} type="text" value={this.state.name} />
                                    {this.state.errors.name && <label className="error text-danger">{this.state.errors.name}</label>}
                                </div>

                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('fee:code')} *</label>
                                    <Input disabled name="code" onChange={this._handleChange} placeholder={t('fee:code')} type="text" value={this.state.code} />
                                    {this.state.errors.code && <label className="error text-danger">{this.state.errors.code}</label>}
                                </div>

                            </div>

                            <div className="row clearfix">
                                <div className="col-sm-3 float-left form-group">
                                    <Button onClick={this.onSave} type="submit" text={t('common:savebtn')} main={true} />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const ShelfManagementEdit = withTranslation()(connect(mapStateToProps)(ShelfManagementEditComponent))

export { ShelfManagementEdit }
